import { Check, Copy, Facebook, Link2, MessageCircle } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const REPORT_PATH = "/reportar";

export const getReportUrl = () =>
  typeof window !== "undefined" ? `${window.location.origin}${REPORT_PATH}` : REPORT_PATH;

/**
 * Fila para copiar / compartir el enlace directo al formulario de reportes.
 */
export const ShareReportLink = ({ variant = "light", className = "" }) => {
  const [copied, setCopied] = useState(false);
  const url = getReportUrl();
  const message = "Reporta una noticia en Choluteca.net";
  const isDark = variant === "dark";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Enlace copiado");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("No se pudo copiar el enlace");
    }
  };

  return (
    <div
      data-testid="share-report-link"
      className={`rounded-xl border ${isDark ? "border-white/20 bg-white/10" : "border-gray-200 bg-gray-50"} p-3 ${className}`}
    >
      <p className={`mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide ${isDark ? "text-white/80" : "text-gray-500"}`}>
        <Link2 className="h-3.5 w-3.5" />
        Enlace directo para compartir
      </p>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <code
          data-testid="share-report-url"
          className={`min-w-0 flex-1 truncate rounded-lg px-3 py-2 text-sm ${isDark ? "bg-black/30 text-white" : "bg-white text-gray-700 border border-gray-200"}`}
        >
          {url}
        </code>
        <div className="flex flex-shrink-0 items-center gap-2">
          <Button type="button" size="sm" variant="outline" onClick={copy} data-testid="copy-report-link">
            {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
            <span className="ml-1.5">{copied ? "Copiado" : "Copiar"}</span>
          </Button>
          <Button
            type="button"
            size="sm"
            variant="outline"
            className="text-green-600"
            asChild
            data-testid="share-report-whatsapp"
          >
            <a
              href={`https://wa.me/?text=${encodeURIComponent(`${message} ${url}`)}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <MessageCircle className="h-4 w-4" />
            </a>
          </Button>
          <Button
            type="button"
            size="sm"
            variant="outline"
            className="text-blue-600"
            asChild
            data-testid="share-report-facebook"
          >
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ShareReportLink;
